export const TEAM_TYPE = {
    PersonalTeam  : 1 ,// 个人团队
    EnterpriseTeam  : 2 // 企业团队
}